module.exports = __webpack_public_path__ + "assets/img/refresh.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/family-plan/assets/images/refresh.png
// module id = 166
// module chunks = 0